import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LanguageEnum, AppModeEnum } from '@project-types/enums';
import { DateRange } from '@project-types/DateRange';
import { SearchTypes } from '@api/shipping-data/types/SearchTypes';
import { User } from '@project-types/User';
import { store } from '@store/store';
import { formatISO, addMonths } from 'date-fns';
import { getDateWithoutTime } from 'components/global/utils';



interface GlobalState {
	user: User | null,
	appMode: AppModeEnum,
	language: LanguageEnum,
	selectedDate: string,
	globalSearch: string | null,
	searchTypes: SearchTypes[] | null,
	searchDateRange: DateRange,
};

const initialState: GlobalState = {
	user: null,
	appMode: AppModeEnum.authStart,
	language: LanguageEnum.cz,
	selectedDate: formatISO(new Date()),
	globalSearch: null,
	searchTypes: [ SearchTypes.searchAll ],
	searchDateRange: {
		from: getDateWithoutTime(formatISO(addMonths(new Date(), -1))),
		to: getDateWithoutTime(formatISO(addMonths(new Date(), 1))),
	}
};



export const globalSlice = createSlice({
	name: 'global',
	initialState,
	reducers: {
		setUser: (state, action: PayloadAction<User | null>) => {
			state.user = action.payload;
		},
		setAppMode: (state, action: PayloadAction<AppModeEnum>) => {
			let mode = action.payload;
			state.appMode = mode === AppModeEnum.authSuccess
				//? AppModeEnum.initDataStart
				//: mode === AppModeEnum.initDataSuccess
				? AppModeEnum.appSuccess
				: mode;
		},
		setLanguage: (state, action: PayloadAction<LanguageEnum>) => {
			state.language = action.payload;
		},
		setSelectedDate: (state, action: PayloadAction<string>) => {
			state.selectedDate = action.payload;
		},
		setGlobalSearch: (state, action: PayloadAction<string | null>) => {
			state.globalSearch = action.payload;
		},
		setSearchTypes: (state, action: PayloadAction<SearchTypes[] | null>) => {
			state.searchTypes = action.payload;
		},
		setSearchDateRange: (state, action: PayloadAction<DateRange>) => {
			state.searchDateRange = action.payload;
		}
	},
});



export const {
	setUser,
	setAppMode,
	setLanguage,
	setSelectedDate,
	setGlobalSearch,
	setSearchTypes,
	setSearchDateRange } = globalSlice.actions;



export const plainSetAppMode = (appMode: AppModeEnum) => store.dispatch(setAppMode(appMode));